import React, { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';

import InflateModal from './InflateModal';
import { Button, Tab, Tabs } from '@attentive-platform/stem-ui';
import { ROSETTA_TAB_ENUM } from '../../../Constants/Constants';
import { useRosettaStore } from '../../../Stores/useRosettaStore';
import { ScopeSelectionIcon, QuotePricingIcon, ResetIcon, TriangleUpIcon } from '../rosettaSvgs';

const RosettaHeader = ({ onReset }) => {
  const { showPricing, inflationPercentage, dispatch } = useRosettaStore(
    useShallow(state => ({
      showPricing: state.showPricing,
      inflationPercentage: state.inflationPercentage,
      dispatch: state.dispatch
    }))
  );

  const [showInflateModal, setShowInflateModal] = useState(false);

  const handleTabChange = (event, newValue) => {
    dispatch({ type: 'SET_SHOW_PRICING', payload: newValue === ROSETTA_TAB_ENUM.QUOTE_PRICING });
  };

  const toggleInflateModal = () => {
    setShowInflateModal(!showInflateModal);
  };

  const handleInflateApply = value => {
    const inflationValue = parseFloat(value);
    if (!isNaN(inflationValue) && inflationValue >= 0) {
      dispatch({ type: 'SET_INFLATION_PERCENTAGE', payload: inflationValue });
    }
  };

  return (
    <header className='rosetta-header'>
      <div className='rosetta-header-content'>
        <div className='rosetta-logo'>
          <h1>Rosetta: Beam AI</h1>
          <span className='rosetta-subtitle'>Scope & Pricing Configurator</span>
        </div>
        <div className='rosetta-tab-navigation'>
          <Tabs
            value={showPricing ? ROSETTA_TAB_ENUM.QUOTE_PRICING : ROSETTA_TAB_ENUM.SCOPE_SELECTION}
            onChange={handleTabChange}
            textColor='primary'
            indicatorColor='primary'>
            <Tab
              value={ROSETTA_TAB_ENUM.SCOPE_SELECTION}
              label={
                <div className='flex items-center gap-1'>
                  <ScopeSelectionIcon />
                  <span>Scope Selection</span>
                </div>
              }
            />
            <Tab
              className='ml-2'
              value={ROSETTA_TAB_ENUM.QUOTE_PRICING}
              label={
                <div className='flex items-center gap-1'>
                  <QuotePricingIcon />
                  <span>Quote & Pricing</span>
                </div>
              }
            />
          </Tabs>
        </div>
        <div>
          <TriangleUpIcon onClick={toggleInflateModal} />
          <Button variant='outlined' onClick={onReset}>
            <ResetIcon />
            Reset
          </Button>
        </div>
      </div>

      {showInflateModal && (
        <InflateModal
          show={showInflateModal}
          onClose={toggleInflateModal}
          onApply={handleInflateApply}
          currentInflationPercentage={inflationPercentage}
        />
      )}
    </header>
  );
};

export default RosettaHeader;
